'use client'

import { cn } from '@snowball-tech/fractal/dist/src/styles/helpers'

import { ProgressBar } from 'react-transition-progress'

type Props = { className?: string }
export default function RouteProgressBar({ className }: Props) {
  return (
    <div className={cn('w-full fixed h-half top-0 z-[53]', className)}>
      <ProgressBar className="bg-black h-full rounded-r-full relative overflow-hidden after:absolute after:inset-0 after:-translate-x-full after:animate-wave after:bg-[linear-gradient(90deg,transparent,rgba(255,255,255,0.5),transparent)] after:content-empty" />
    </div>
  )
}
